/* ============================================================================
   NAMING THIS LATER — shared behaviour engine  (playbook §5.3 · §5.4 · §5.6 · §12.5)
   Loaded from <head> with `defer`, so it is IMMUNE to the fragile per-section
   {% javascript %} bundle: one section throwing can never kill these.
   Everything binds by DOCUMENT-LEVEL DELEGATION, so it survives
   `shopify:section:load` and the cart's Section-Rendering DOM swaps.
   ========================================================================= */
(function () {
  'use strict';

  var NTL = window.NTL = window.NTL || {};
  var MOBILE  = window.matchMedia('(max-width:760px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var HOVER   = window.matchMedia('(hover:hover) and (pointer:fine)');
  var still   = function () { return MOBILE.matches || REDUCED.matches; };
  NTL.still = still;

  function on(type, sel, fn, opts) {
    document.addEventListener(type, function (e) {
      var t = e.target && e.target.closest ? e.target.closest(sel) : null;
      if (t && document.contains(t)) fn.call(t, e, t);
    }, opts || false);
  }
  NTL.on = on;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  NTL.$ = $; NTL.$$ = $$;

  /* ── money ───────────────────────────────────────────────────────────── */
  /* The active market's format, worked out from a value Liquid's own `money` filter
     rendered on this page (window.NTL_MONEY.probe, see snippets/styles-scripts.liquid).
     Shopify.moneyFormat is the SHOP's format and does not change with the market, so
     a shopper who switched to France saw € on the server-rendered price and $ on every
     price JavaScript repainted next to it. Deriving from the probe means the two can
     never disagree, whatever the merchant has configured. */
  var MFMT = (function () {
    var m = window.NTL_MONEY;
    if (!m || typeof m.probe !== 'string' || !m.probeCents) return null;
    var run = m.probe.match(/\d[\d.,\s'\u2019\u00a0]*\d|\d/);
    if (!run) return null;
    var num = run[0];
    var out = {
      prefix: m.probe.slice(0, run.index),
      suffix: m.probe.slice(run.index + num.length),
      decimals: 2, thousands: ',', decimal: '.'
    };
    /* the last separator followed by exactly two digits is the decimal one */
    var dec = num.match(/([.,\s'\u2019\u00a0])(\d{2})$/);
    if (dec) { out.decimal = dec[1]; out.decimals = 2; }
    else { out.decimals = 0; out.decimal = ''; }
    var body = out.decimals ? num.slice(0, num.length - 3) : num;
    var th = body.match(/[.,\s'\u2019\u00a0]/);
    out.thousands = th ? th[0] : '';
    return out;
  })();

  NTL.money = function (cents) {
    if (MFMT) {
      var v = Number(cents || 0) / 100;
      var parts = v.toFixed(MFMT.decimals).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + MFMT.thousands);
      return MFMT.prefix + (parts.length > 1 ? parts[0] + MFMT.decimal + parts[1] : parts[0]) + MFMT.suffix;
    }
    var fmt = (window.Shopify && window.Shopify.moneyFormat) || '${{amount}}';
    var n = Number(cents || 0) / 100;
    function fill(precision, thousands, decimal) {
      var parts = n.toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + (thousands || ','));
      return parts.length > 1 ? parts.join(decimal || '.') : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount':                     return fill(2, ',', '.');
        case 'amount_no_decimals':         return fill(0, ',', '.');
        case 'amount_with_comma_separator':return fill(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fill(0, '.', ',');
        case 'amount_with_space_separator':return fill(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fill(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return fill(2, "'", '.');
        default: return fill(2, ',', '.');
      }
    });
  };

  /* ── country picker: keep the panel on screen ────────────────────────────
     It lives in the footer's bottom row, which is `space-between` — so where the
     picker lands depends on what else is in that row (copyright, notes, payment
     icons). Anchored left it overflows the right edge when the picker sits at the
     end; anchored right it would overflow the left when it sits at the start. So
     it is measured after opening and flipped only if it actually overflows. */
  function ctryPlace(d) {
    var pop = d && d.querySelector('.ctry-pop');
    if (!pop) return;
    pop.style.left = ''; pop.style.right = '';
    var vw = document.documentElement.clientWidth || window.innerWidth;
    if (pop.getBoundingClientRect().right > vw - 8) {
      pop.style.left = 'auto'; pop.style.right = '0';
      /* ...unless flipping pushes it off the other side, which is worse */
      if (pop.getBoundingClientRect().left < 8) { pop.style.left = '0'; pop.style.right = 'auto'; }
    }
  }
  NTL.ctryPlace = ctryPlace;
  on('click', '[data-ntl-ctry] > summary', function (e, sm) {
    var d = sm.parentElement;
    requestAnimationFrame(function () { if (d.hasAttribute('open')) ctryPlace(d); });
  });
  window.addEventListener('resize', function () {
    $$('details[data-ntl-ctry][open]').forEach(ctryPlace);
  });

  /* ── country picker: click-away and Escape ───────────────────────────── */
  on('click', 'body', function (e) {
    $$('details[data-ntl-ctry][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('details[data-ntl-ctry][open]').forEach(function (d) {
      d.removeAttribute('open');
      var sm = d.querySelector('summary');
      if (sm) sm.focus();
    });
  });

  /* ── toast (§12.6) ───────────────────────────────────────────────────── */
  var toastHost;
  NTL.toast = function (msg, kind) {
    if (!toastHost) {
      toastHost = document.createElement('div');
      toastHost.className = 'ntl ntl-toasts';
      toastHost.setAttribute('role', 'status');
      toastHost.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastHost);
    }
    var t = document.createElement('div');
    t.className = 'ntl-toast' + (kind ? ' is-' + kind : '');
    t.innerHTML = '<i class="fa-solid ' + (kind === 'err' ? 'fa-circle-question' : 'fa-circle-check') +
                  '"></i><span></span>';
    t.querySelector('span').textContent = msg;
    toastHost.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('in'); });
    var kill = function () { t.classList.remove('in'); setTimeout(function () { t.remove(); }, 350); };
    var timer = setTimeout(kill, 4200);
    t.addEventListener('mouseenter', function () { clearTimeout(timer); });
    t.addEventListener('mouseleave', function () { timer = setTimeout(kill, 1600); });
  };

  /* ── 1) SCROLL REVEAL — fires once, staggered, fade-only on mobile ───── */
  var revealSel = '.ntl .rvl';
  var revealIO = null;
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$(revealSel).forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (en, i) {
          if (!en.isIntersecting) return;
          var el = en.target;
          setTimeout(function () { el.classList.add('in'); }, still() ? 0 : Math.min(i, 6) * 65);
          obs.unobserve(el);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    }
    $$(revealSel).forEach(function (el) {
      if (el.dataset.ntlRv) return;
      el.dataset.ntlRv = '1';
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) { el.classList.add('in'); return; } /* above the fold: never reveal */
      revealIO.observe(el);
    });
    /* safety net — content is never left invisible if the observer misfires */
    setTimeout(function () { $$(revealSel).forEach(function (el) { el.classList.add('in'); }); }, 3000);
  }
  NTL.initReveal = initReveal;

  /* ── 2) VIDEO — play only while visible; poster-only when we shouldn't load
         (§12.4c: reduced-motion / Save-Data / slow network) ─────────────── */
  var videoIO = null;
  function mayPlayVideo() {
    if (REDUCED.matches) return false;
    var c = navigator.connection;
    if (c && (c.saveData || /^(slow-2g|2g)$/.test(c.effectiveType || ''))) return false;
    return true;
  }
  NTL.mayPlayVideo = mayPlayVideo;
  function initVideo() {
    var vids = $$('.ntl video[data-ntl-video]');
    if (!vids.length) return;
    if (!mayPlayVideo()) {
      vids.forEach(function (v) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {} });
      return;
    }
    if (!('IntersectionObserver' in window)) return;
    if (!videoIO) {
      videoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting && !document.hidden) {
            /* mobile gets a lighter source where one is supplied */
            if (!v.src && v.dataset.src) v.src = (MOBILE.matches && v.dataset.srcM) || v.dataset.src;
            var p = v.play();
            if (p && p.catch) p.catch(function () {
              v.addEventListener('canplay', function once () {
                v.removeEventListener('canplay', once);
                var r = v.play(); if (r && r.catch) r.catch(function () {});
              });
            });
          } else { try { v.pause(); } catch (e) {} }
        });
      }, { threshold: 0.15, rootMargin: '250px 0px' });
    }
    vids.forEach(function (v) { if (!v.dataset.ntlVo) { v.dataset.ntlVo = '1'; videoIO.observe(v); } });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) $$('.ntl video[data-ntl-video]').forEach(function (v) { try { v.pause(); } catch (e) {} });
    else initVideo();
  });
  NTL.initVideo = initVideo;

  /* ── 3) RAILS — arrows + desktop drag + disabled-state sync ──────────── */
  function railStep(rail) {
    var card = rail.firstElementChild;
    var gap = parseFloat(getComputedStyle(rail).columnGap || '24') || 24;
    return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
  }
  function syncRail(rail) {
    var wrap = rail.closest('[data-ntl-rail-wrap]') || rail.parentElement;
    if (!wrap) return;
    var prev = wrap.querySelector('[data-ntl-rail-prev]'), next = wrap.querySelector('[data-ntl-rail-next]');
    var max = rail.scrollWidth - rail.clientWidth - 2;
    if (prev) prev.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= max;
  }
  NTL.syncRail = syncRail;
  function initRails() {
    $$('[data-ntl-rail]').forEach(function (rail) {
      if (rail.dataset.ntlRailInit) { syncRail(rail); return; }
      rail.dataset.ntlRailInit = '1';
      rail.addEventListener('scroll', function () { syncRail(rail); }, { passive: true });
      window.addEventListener('resize', function () { syncRail(rail); });
      syncRail(rail);
      if (rail.hasAttribute('data-ntl-rail-drag')) {
        var down = false, moved = 0, x0 = 0, s0 = 0;
        rail.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return;
          down = true; moved = 0; x0 = e.clientX; s0 = rail.scrollLeft;
          /* Deliberately NO setPointerCapture here. Capturing on pointerdown
             retargets the subsequent `click` to the rail itself, so a plain
             click never reaches the product link inside the card and the whole
             card behaves as if it were dead. Capture is taken below, only once
             a real drag has started — which is the only time it is needed. */
        });
        rail.addEventListener('pointermove', function (e) {
          if (!down) return;
          var d = e.clientX - x0;
          if (!moved && Math.abs(d) > 4) {
            moved = 1; rail.classList.add('drag');
            try { rail.setPointerCapture(e.pointerId); } catch (err) {}
          }
          if (moved) rail.scrollLeft = s0 - d;
        });
        var up = function (e) {
          if (!down) return;
          down = false; rail.classList.remove('drag');
          try { if (rail.hasPointerCapture(e.pointerId)) rail.releasePointerCapture(e.pointerId); } catch (err) {}
        };
        rail.addEventListener('pointerup', up);
        rail.addEventListener('pointercancel', up);
        rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = 0; } }, true);
      }
    });
  }
  NTL.initRails = initRails;
  on('click', '[data-ntl-rail-prev],[data-ntl-rail-next]', function (e, btn) {
    var wrap = btn.closest('[data-ntl-rail-wrap]') || btn.parentElement;
    var rail = wrap && wrap.querySelector('[data-ntl-rail]');
    if (!rail) return;
    var dir = btn.hasAttribute('data-ntl-rail-prev') ? -1 : 1;
    var by = dir * railStep(rail) * 2;
    /* scrollLeft += jumps: the row teleported a page sideways with no motion at
       all. scrollBy with a behavior animates it, and honours the reader's
       reduced-motion preference instead of overriding it. */
    if (rail.scrollBy) {
      rail.scrollBy({ left: by, behavior: REDUCED.matches ? 'auto' : 'smooth' });
    } else {
      rail.scrollLeft += by;
    }
    setTimeout(function () { syncRail(rail); }, 450);
  });

  /* ── 4) COUNT-UP + BAR FILL ──────────────────────────────────────────── */
  function initCounters() {
    if (!('IntersectionObserver' in window)) {
      $$('.ntl [data-ntl-count]').forEach(function (el) {
        el.textContent = el.dataset.ntlInt === '1'
          ? String(Math.round(parseFloat(el.dataset.ntlCount)))
          : parseFloat(el.dataset.ntlCount).toFixed(2);
      });
      $$('.ntl [data-ntl-bar]').forEach(function (s) { s.style.width = s.dataset.ntlBar + '%'; });
      return;
    }
    $$('.ntl [data-ntl-count],.ntl [data-ntl-bar]').forEach(function (el) {
      if (el.dataset.ntlCo) return;
      el.dataset.ntlCo = '1';
      var io = new IntersectionObserver(function (es, obs) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          obs.disconnect();
          if (el.hasAttribute('data-ntl-bar')) { el.style.width = el.dataset.ntlBar + '%'; return; }
          var to = parseFloat(el.dataset.ntlCount), isInt = el.dataset.ntlInt === '1';
          if (still()) { el.textContent = isInt ? String(Math.round(to)) : to.toFixed(2); return; }
          var t0 = null;
          (function step(t) {
            if (!t0) t0 = t;
            var p = Math.min((t - t0) / 1100, 1);
            var v = to * (1 - Math.pow(1 - p, 3));
            el.textContent = isInt ? String(Math.round(v)) : v.toFixed(2);
            if (p < 1) requestAnimationFrame(step);
          })(performance.now());
        });
      }, { threshold: 0.35 });
      io.observe(el);
    });
  }
  NTL.initCounters = initCounters;

  /* ── 5) ACCORDIONS — one open at a time within a group ───────────────── */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var group = d.closest('[data-ntl-accordion]');
    if (!group) return;
    $$('details', group).forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  /* ── 6) CART — reuse the theme's engine, never its UI (§5.3 · §5.5) ──── */
  var CART_SECTIONS = ['cart-count-badge', 'offcanvas-cart'];
  function cartEl() { return document.querySelector('cart-container'); }
  NTL.openCartDrawer = function () {
    var oc = document.querySelector('#offcanvas-cart');
    if (oc && window.bootstrap && window.bootstrap.Offcanvas) {
      window.bootstrap.Offcanvas.getOrCreateInstance(oc).show();
      return true;
    }
    return false;
  };
  NTL.syncCartCounts = function (count) {
    if (typeof count !== 'number') return;
    $$('[data-ntl-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle('is-zero', count === 0);
      el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop');
    });
  };

  /* ONE add-to-cart helper, wired to every `.ntl-add-form` by delegation */
  on('submit', 'form.ntl-add-form', function (e, form) {
    if (form.dataset.ntlBusy === '1') { e.preventDefault(); return; }
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var restore = btn ? btn.innerHTML : null;
    form.dataset.ntlBusy = '1';
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    var fd = new FormData(form);
    fd.append('sections', CART_SECTIONS.join(','));
    fd.append('sections_url', window.location.pathname);

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: fd
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message) || 'Could not add to cart');
        var c = cartEl();
        if (c && res.data.sections) c.reloadCartElements(res.data.sections);
        window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: res.data }));
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-ok'); }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          NTL.syncCartCounts(cart.item_count);
        }).catch(function () {});
      })
      .then(function () { NTL.openCartDrawer(); })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-err'); }
        NTL.toast(err.message || 'Could not add to cart', 'err');
      })
      .finally(function () {
        setTimeout(function () {
          form.dataset.ntlBusy = '0';
          if (btn) {
            btn.classList.remove('is-loading', 'is-ok', 'is-err');
            btn.removeAttribute('aria-busy'); btn.disabled = false;
            if (restore != null) btn.innerHTML = restore;
          }
        }, 1200);
      });
  });

  /* qty stepper — drives the THEME's [name="updates[]"] input + native change */
  on('click', '[data-ntl-qty]', function (e, btn) {
    e.preventDefault();
    var wrap = btn.closest('[data-ntl-qty-wrap]');
    var input = wrap && wrap.querySelector('input[type="number"],input[name="updates[]"],input[name="quantity"]');
    if (!input) return;
    var dir = btn.dataset.ntlQty === 'up' ? 1 : -1;
    var min = input.hasAttribute('min') ? Number(input.min) : 0;
    var next = Math.max(min, (Number(input.value) || 0) + dir);
    if (String(next) === String(input.value)) return;
    input.value = next;
    btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop');
    clearTimeout(input._ntlT);
    input._ntlT = setTimeout(function () {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, input.name === 'updates[]' ? 300 : 0);
  });

  /* preserve focus + scroll across the cart's Section-Rendering swap (§12.7) */
  (function () {
    var memo = null;
    window.addEventListener('kt.cart.reloaded', function () {
      if (!memo) return;
      var scroller = document.querySelector('#offcanvas-cart .offcanvas-body, [data-ntl-cart-scroll]');
      if (scroller && memo.top != null) scroller.scrollTop = memo.top;
      if (memo.key) {
        var back = document.querySelector('[data-line-item-key="' + memo.key + '"]');
        if (back && back.focus) try { back.focus({ preventScroll: true }); } catch (e) {}
      }
      memo = null;
      initAll();
    });
    document.addEventListener('change', function (e) {
      var i = e.target;
      if (!i || i.name !== 'updates[]') return;
      var scroller = document.querySelector('#offcanvas-cart .offcanvas-body, [data-ntl-cart-scroll]');
      memo = { key: i.dataset.lineItemKey, top: scroller ? scroller.scrollTop : null };
    }, true);
  })();


  /* ── 6b) CART: undo-remove + lazy recommendations (§12.7) ─────────────── */

  /* Remove with UNDO — capture the line payload BEFORE the theme's handler
     mutates the cart, then offer a ~6s re-add. The theme's own click handler
     still runs (we never preventDefault), so the removal itself stays its job. */
  on('click', '.btn-line-item-remove', function (e, btn) {
    var payload = null;
    try { payload = JSON.parse(btn.dataset.ntlUndo || 'null'); } catch (err) {}
    var row = btn.closest('[data-ntl-line]');
    var title = row ? (row.querySelector('.ntl-line-t') || {}).textContent : '';
    if (row) row.classList.add('is-going');
    if (!payload) return;
    var used = false;
    var host = document.createElement('div');
    host.className = 'ntl ntl-toasts';
    host.setAttribute('role', 'status');
    var t = document.createElement('div');
    t.className = 'ntl-toast';
    t.innerHTML = '<span></span>';
    t.querySelector('span').textContent = 'Removed' + (title ? ' · ' + title.trim() : '');
    var undo = document.createElement('button');
    undo.type = 'button';
    undo.textContent = 'Undo';
    undo.style.cssText = 'margin-left:auto;color:#D8DA23;text-decoration:underline;text-underline-offset:3px;font:inherit;background:none;border:0;cursor:pointer';
    t.appendChild(undo);
    host.appendChild(t);
    document.body.appendChild(host);
    requestAnimationFrame(function () { t.classList.add('in'); });
    var kill = function () {
      t.classList.remove('in');
      setTimeout(function () { host.remove(); }, 350);
    };
    var timer = setTimeout(kill, 6000);
    undo.addEventListener('click', function () {
      if (used) return; used = true;
      clearTimeout(timer); kill();
      payload.sections = CART_SECTIONS.join(',');
      payload.sections_url = window.location.pathname;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [payload], sections: CART_SECTIONS, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var c = cartEl();
          if (c && d.sections) c.reloadCartElements(d.sections);
          NTL.toast('Item restored');
        })
        .catch(function () { NTL.toast('Could not restore that item', 'err'); });
    });
  });

  /* Recommendations — lazy, complementary -> related -> hide. Never an empty rail. */
  function loadCartRecs() {
    var host = document.querySelector('[data-ntl-recs]');
    if (!host || host.dataset.ntlRecsDone === '1') return;
    var firstLine = document.querySelector('[data-ntl-line]');
    if (!firstLine) return;
    host.dataset.ntlRecsDone = '1';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return null;
        var inCart = cart.items.map(function (i) { return i.product_id; });
        var pid = cart.items[0].product_id;
        function tryIntent(intent) {
          return fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent)
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .catch(function () { return { products: [] }; });
        }
        return tryIntent('complementary').then(function (d) {
          if (d.products && d.products.length) return { d: d, inCart: inCart };
          return tryIntent('related').then(function (d2) { return { d: d2, inCart: inCart }; });
        });
      })
      .then(function (res) {
        if (!res) return;
        var items = (res.d.products || []).filter(function (p) { return res.inCart.indexOf(p.id) === -1; }).slice(0, 6);
        if (!items.length) { host.hidden = true; return; }   /* hide the whole band, never "no recommendations" */
        var rail = host.querySelector('[data-ntl-recs-rail]');
        rail.innerHTML = items.map(function (p) {
          var v = (p.variants || [])[0] || {};
          var img = p.featured_image || (p.images || [])[0] || '';
          var src = img ? String(img).replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : '';
          return '<div class="ntl-rec">' +
            '<a class="ntl-rec-i" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
              (src ? '<img src="' + src + '" alt="" width="300" height="375" loading="lazy" decoding="async">' : '') +
            '</a>' +
            '<a class="ntl-rec-t" href="' + p.url + '">' + p.title + '</a>' +
            '<span class="ntl-rec-p">' + NTL.money(p.price) + '</span>' +
            (v.available
              ? '<form class="ntl-add-form"><input type="hidden" name="id" value="' + v.id + '">' +
                '<button class="btn ntl-rec-add" type="submit">Add</button></form>'
              : '<button class="btn ntl-rec-add" disabled>Sold out</button>') +
            '</div>';
        }).join('');
        host.hidden = false;
      })
      .catch(function () { host.hidden = true; });
  }
  /* only fetch once the drawer is actually opened / the cart page is shown */
  document.addEventListener('shown.bs.offcanvas', function (e) {
    if (e.target && e.target.id === 'offcanvas-cart') loadCartRecs();
  });
  window.addEventListener('kt.cart.reloaded', function () {
    var h = document.querySelector('[data-ntl-recs]');
    if (h) h.dataset.ntlRecsDone = '';
    if (document.querySelector('#offcanvas-cart.show') || document.querySelector('[data-ntl-cart-page]')) loadCartRecs();
  });
  if (document.querySelector('[data-ntl-cart-page]')) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadCartRecs);
    else loadCartRecs();
  }

  /* cart note save (reuses the theme's <cart-note> element where present) */
  on('click', '.ntl-note-save', function (e, btn) {
    e.preventDefault();
    var ta = btn.closest('.ntl-note-in').querySelector('textarea');
    if (!ta) return;
    btn.classList.add('is-loading');
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: ta.value })
    }).then(function () { NTL.toast('Note saved'); })
      .catch(function () { NTL.toast('Could not save the note', 'err'); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });


  /* ── 6c) PRODUCT RECOMMENDATIONS — the section renders skeletons, this fills it.
     Shopify's `recommendations` object is empty on a normal page render; it only
     populates when the section is fetched through the Recommendations API. So the
     section paints skeletons and we swap in the real markup (§11.2). */
  /* Swap the loading skeletons for the range rendered alongside them. Only when
     there is no fallback at all does the band go away — an empty band is worse
     than a related one, but a broken one is worse than nothing. */
  function showRecsFallback(sec) {
    var fb = sec.querySelector('[data-ntl-prec-fallback]');
    var skel = sec.querySelector('[data-ntl-prec-skel]');
    if (!fb) { sec.hidden = true; return; }
    if (skel) skel.remove();
    fb.hidden = false;
    if (NTL.initAll) NTL.initAll();
  }

  function loadProductRecs() {
    $$('[data-ntl-prec]').forEach(function (sec) {
      if (sec.dataset.ntlPrecDone === '1') return;
      sec.dataset.ntlPrecDone = '1';
      var pid = sec.dataset.ntlPrec;
      var sid = sec.dataset.ntlPrecSection;
      var intent = sec.dataset.ntlPrecIntent || 'related';
      var limit = sec.dataset.ntlPrecLimit || 4;
      if (!pid || !sid) return;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.product_recommendations_url)
        || '/recommendations/products';
      var url = base + '?section_id=' + encodeURIComponent(sid) +
                '&product_id=' + encodeURIComponent(pid) +
                '&intent=' + encodeURIComponent(intent) +
                '&limit=' + encodeURIComponent(limit);
      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('recs ' + r.status)); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ntl-prec], .ntl-pgrid');
          if (!fresh) throw new Error('no section in the response');
          /* Nothing came back for this product. Shopify's `related` intent stays
             empty until the shop has enough behavioural data, so hiding the band
             meant "You may also like" was simply missing from most product pages.
             Show the server-rendered fallback range instead, and only hide when
             there is no fallback either. */
          if (!fresh.querySelector('.pc-r')) { showRecsFallback(sec); return; }
          sec.replaceWith(fresh);
          if (NTL.initAll) NTL.initAll();
        })
        .catch(function () { showRecsFallback(sec); });
    });
  }
  NTL.loadProductRecs = loadProductRecs;

  /* ── 7) WISHLIST — localStorage engine, delegated triggers (§5.4) ─────── */
  var WKEY = 'ntl:wishlist';
  function wRead() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wWrite(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
    window.dispatchEvent(new CustomEvent('ntl:wishlist:change', { detail: list }));
  }
  NTL.wishlist = {
    all: wRead,
    count: function () { return wRead().length; },
    has: function (h) { return wRead().some(function (i) { return i.handle === h; }); },
    toggle: function (item) {
      var list = wRead(), i = list.findIndex(function (x) { return x.handle === item.handle; });
      if (i > -1) list.splice(i, 1); else list.unshift(item);
      wWrite(list); return i === -1;
    },
    remove: function (h) { wWrite(wRead().filter(function (i) { return i.handle !== h; })); }
  };
  on('click', '[data-ntl-fav]', function (e, btn) {
    e.preventDefault(); e.stopPropagation();
    var d = btn.dataset;
    var added = NTL.wishlist.toggle({
      handle: d.ntlFav, title: d.ntlFavTitle || '', url: d.ntlFavUrl || '',
      image: d.ntlFavImage || '', price: d.ntlFavPrice || '', sub: d.ntlFavSub || '',
      variant: d.ntlFavVariant || ''
    });
    btn.classList.toggle('on', added);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    if (added) { btn.classList.remove('burst'); void btn.offsetWidth; btn.classList.add('burst'); }
  });
  function syncWishlist() {
    var list = wRead(), n = list.length;
    $$('[data-ntl-fav]').forEach(function (b) {
      var on_ = list.some(function (i) { return i.handle === b.dataset.ntlFav; });
      b.classList.toggle('on', on_);
      b.setAttribute('aria-pressed', on_ ? 'true' : 'false');
    });
    $$('[data-ntl-fav-count]').forEach(function (el) {
      el.textContent = String(n); el.classList.toggle('is-zero', n === 0);
    });
  }
  window.addEventListener('ntl:wishlist:change', syncWishlist);
  NTL.syncWishlist = syncWishlist;


  /* render the saved-items list from the localStorage snapshot (§5.4: rich line
     items — a name+price row reads as broken; and a snapshot renders instantly
     and offline, with no request on open) */
  function renderWishlist() {
    var root = $('[data-ntl-wishlist-root]');
    if (!root) return;
    var grid = root.querySelector('.ntl-wl-grid');
    var empty = root.querySelector('.ntl-wl-empty');
    var tpl = $('[data-ntl-wishlist-item]');
    if (!grid || !tpl) return;
    var list = wRead();
    grid.textContent = '';
    if (!list.length) {
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    list.forEach(function (it) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('href', it.url || '#');
      var img = node.querySelector('img');
      if (img && it.image) { img.src = it.image; img.alt = it.title || ''; }
      else if (img) { img.remove(); }
      var t = node.querySelector('.ntl-wl-t'); if (t) t.textContent = it.title || '';
      var sub = node.querySelector('.ntl-wl-s');
      if (sub) { if (it.sub) sub.textContent = it.sub; else sub.remove(); }
      var pr = node.querySelector('.ntl-wl-p'); if (pr) pr.textContent = it.price || '';
      var rm = document.createElement('button');
      rm.type = 'button'; rm.className = 'ntl-wl-x-i';
      rm.setAttribute('aria-label', 'Remove ' + (it.title || 'item'));
      rm.innerHTML = '<i class="fa-solid fa-xmark" aria-hidden="true"></i>';
      rm.addEventListener('click', function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        NTL.wishlist.remove(it.handle);
      });
      node.appendChild(rm);
      grid.appendChild(node);
    });
  }
  window.addEventListener('ntl:wishlist:change', renderWishlist);
  NTL.renderWishlist = renderWishlist;

  /* ── 8) RECENTLY VIEWED (§5.4) ───────────────────────────────────────── */
  var RKEY = 'ntl:recent';
  NTL.recent = {
    all: function () { try { return JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) { return []; } },
    push: function (item) {
      if (!item || !item.handle) return;
      var list = NTL.recent.all().filter(function (i) { return i.handle !== item.handle; });
      list.unshift(item);
      try { localStorage.setItem(RKEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
    }
  };

  /* ── 9) HEADER — sticky shadow, rAF-throttled with a hysteresis dead-band
         so it can never flip-flop on the threshold (§8.0 step 6) ────────── */
  (function () {
    var ticking = false, stuck = false;
    function apply() {
      ticking = false;
      var y = window.scrollY;
      if (!stuck && y > 12) { stuck = true; }
      else if (stuck && y < 4) { stuck = false; }
      else return;
      $$('[data-ntl-header]').forEach(function (h) { h.classList.toggle('stuck', stuck); });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }, { passive: true });
    apply();
  })();

  /* ── 10) DRAWERS (mobile nav, search, wishlist) — focus trap, ESC,
          scroll-lock, focus restore (§12.5) ─────────────────────────────── */
  var openDrawer = null, lastFocus = null, scrollY = 0;
  function trapFocus(e) {
    if (!openDrawer || e.key !== 'Tab') return;
    var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', openDrawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }
  NTL.openPanel = function (panel) {
    if (!panel) return;
    lastFocus = document.activeElement;
    scrollY = window.scrollY;
    openDrawer = panel;
    panel.classList.add('on');
    panel.removeAttribute('aria-hidden');
    $$('[data-ntl-scrim]').forEach(function (s) { s.classList.add('on'); });
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.width = '100%';
    var f = panel.querySelector('button,a[href],input');
    if (f) setTimeout(function () { try { f.focus(); } catch (e) {} }, 60);
    document.addEventListener('keydown', trapFocus);
  };
  NTL.closePanel = function () {
    if (!openDrawer) return;
    openDrawer.classList.remove('on');
    openDrawer.setAttribute('aria-hidden', 'true');
    $$('[data-ntl-scrim]').forEach(function (s) { s.classList.remove('on'); });
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    document.removeEventListener('keydown', trapFocus);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
    openDrawer = null;
  };
  on('click', '[data-ntl-open]', function (e, btn) {
    e.preventDefault();
    NTL.openPanel(document.querySelector(btn.dataset.ntlOpen));
  });
  on('click', '[data-ntl-close]', function (e) { e.preventDefault(); NTL.closePanel(); });
  on('click', '[data-ntl-scrim]', function () { NTL.closePanel(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') NTL.closePanel(); });
  on('click', '[data-ntl-drawer] a[href]', function () { NTL.closePanel(); });

  /* mobile nav accordion */
  on('click', '[data-ntl-acc]', function (e, btn) {
    e.preventDefault();
    var sub = document.querySelector(btn.dataset.ntlAcc);
    if (!sub) return;
    var open = sub.classList.toggle('on');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ── 11) MEGA MENU — hover on desktop, grace period, ESC, focus-out ─────
     11a) PANES — hovering an item in the mega menu's left rail swaps the
     columns beside it, the way a department menu does. Everything is read off
     the markup, so adding a menu item in Shopify needs no change here:
       [data-ntl-pane]   on a rail link -> the id of the pane it opens ('' = none)
       [data-ntl-groups] on a rail link -> how many columns that pane holds
       [data-fb-min]     on the panel   -> keep the panel's own standing columns
                                           while the hovered item has fewer
                                           columns than this
     The panel ships with data-fb="1" and no pane open, so the no-JS/pre-JS
     state is the correct default state rather than an empty box. */
  function initMegaPanes(panel) {
    if (panel.dataset.ntlPanesInit) return;
    panel.dataset.ntlPanesInit = '1';
    var rails = $$('[data-ntl-pane]', panel);
    var panes = $$('.mg-pane', panel);
    if (!rails.length) return;
    var min = parseInt(panel.dataset.fbMin, 10);
    if (isNaN(min)) min = 2;

    function mark(rail, pane) {
      panes.forEach(function (p) { p.classList.toggle('is-on', p === pane); });
      rails.forEach(function (r) {
        if (r.hasAttribute('aria-expanded')) {
          r.setAttribute('aria-expanded', r === rail && pane ? 'true' : 'false');
        }
      });
    }
    function reset() { mark(null, null); panel.dataset.fb = '1'; }
    function show(rail) {
      var id = rail.dataset.ntlPane;
      var pane = id ? document.getElementById(id) : null;
      mark(rail, pane);
      var groups = parseInt(rail.dataset.ntlGroups, 10) || 0;
      /* an item with no pane of its own leaves the standing columns alone */
      panel.dataset.fb = (!pane || groups < min) ? '1' : '0';
    }

    rails.forEach(function (r) {
      r.addEventListener('mouseenter', function () { if (HOVER.matches) show(r); });
      r.addEventListener('focus', function () { show(r); });
      /* same bargain as the trigger on a touch device: the first tap on a rail
         item that has columns reveals them, the second tap goes to its
         collection. Without it the columns exist on a tablet and nothing can
         ever show them. */
      r.addEventListener('click', function (e) {
        if (HOVER.matches) return;
        var id = r.dataset.ntlPane;
        var pane = id ? document.getElementById(id) : null;
        if (pane && !pane.classList.contains('is-on')) { e.preventDefault(); show(r); }
      });
    });
    /* only leaving the whole panel resets it — crossing the gap from the rail
       into the columns it just opened must not close them */
    panel.addEventListener('mouseleave', function () { if (HOVER.matches) reset(); });
    panel.ntlResetPanes = reset;

    /* KEYBOARD PATH THROUGH THE COLUMNS.
       In document order the whole rail comes before any pane, so plain Tab walks
       every rail item first — and since focusing a rail item swaps the pane,
       whatever pane was open is gone by the time Tab reaches the columns. The
       links a mouse user sees on hover were reachable by no keystroke at all.
       So Tab off a rail item goes INTO the pane it just opened, and Tab off the
       last link in that pane carries on to the next rail item. Shift+Tab
       retraces it. That gives the keyboard the same shape the pointer has. */
    function paneLinks(pane) { return $$('a[href]', pane); }
    function paneOf(rail) {
      var id = rail.dataset.ntlPane;
      var pane = id ? document.getElementById(id) : null;
      return pane && pane.classList.contains('is-on') ? pane : null;
    }
    rails.forEach(function (r) {
      r.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || e.shiftKey) return;
        var pane = paneOf(r);
        if (!pane) return;
        var f = paneLinks(pane);
        if (!f.length) return;
        e.preventDefault();
        f[0].focus();
      });
    });
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var pane = e.target.closest ? e.target.closest('.mg-pane') : null;
      if (!pane) return;
      var f = paneLinks(pane);
      if (!f.length) return;
      var rail = panel.querySelector('[data-ntl-pane="' + pane.id + '"]');
      if (!rail) return;
      if (e.shiftKey && e.target === f[0]) {
        e.preventDefault(); rail.focus();
      } else if (!e.shiftKey && e.target === f[f.length - 1]) {
        var next = rails[rails.indexOf(rail) + 1];
        if (next) { e.preventDefault(); next.focus(); }
      }
    });
  }

  /* ESC and focus-out belong to the DOCUMENT, not to a panel, so they are bound
     once. Binding them per button meant every shopify:section:load — which hands
     back fresh nodes without the init flag — left another pair behind for the
     life of the page. */
  var megaDocBound = false;
  function eachOpenMega(fn) {
    $$('[data-ntl-mega]').forEach(function (p) { if (p.ntlShut) fn(p); });
  }
  function bindMegaDoc() {
    if (megaDocBound) return;
    megaDocBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      eachOpenMega(function (p) {
        var was = p.classList.contains('on');
        p.ntlShut();
        /* ESC hands the keyboard back to the control that opened it — but that
           control opens the panel ON FOCUS, so without this flag the panel
           reopened on the way out and ESC did nothing at all. */
        if (was && p.contains(document.activeElement) && p.ntlBtn) {
          p.ntlNoOpen = true;
          p.ntlBtn.focus();
          setTimeout(function () { p.ntlNoOpen = false; }, 0);
        }
      });
    });
    document.addEventListener('focusin', function (e) {
      eachOpenMega(function (p) {
        if (!p.classList.contains('on')) return;
        if (!p.contains(e.target) && e.target !== p.ntlBtn) p.ntlShut();
      });
    });
    /* on a touch device there is no mouseleave to close the panel with */
    document.addEventListener('click', function (e) {
      if (HOVER.matches) return;
      eachOpenMega(function (p) {
        if (!p.classList.contains('on')) return;
        if (!p.contains(e.target) && e.target !== p.ntlBtn) p.ntlShut();
      });
    });
  }

  function initMega() {
    $$('[data-ntl-mega]').forEach(initMegaPanes);
    bindMegaDoc();
    $$('[data-ntl-mega-btn]').forEach(function (btn) {
      if (btn.dataset.ntlMegaInit) return;
      btn.dataset.ntlMegaInit = '1';
      var panel = document.querySelector(btn.dataset.ntlMegaBtn);
      if (!panel) return;
      var t = null, DESK = window.matchMedia('(min-width:901px)');
      function open() {
        clearTimeout(t); panel.hidden = false; void panel.offsetHeight;
        panel.classList.add('on'); btn.setAttribute('aria-expanded', 'true');
      }
      function shut() {
        panel.classList.remove('on'); btn.setAttribute('aria-expanded', 'false');
        /* a closed panel must not reopen still showing the last hovered pane */
        if (panel.ntlResetPanes) panel.ntlResetPanes();
        clearTimeout(t); t = setTimeout(function () { panel.hidden = true; }, 280);
      }
      function leave() { clearTimeout(t); t = setTimeout(shut, 140); }
      panel.ntlShut = shut;
      panel.ntlBtn = btn;
      /* HOVER.matches as well as DESK.matches: a tap on a touch screen
         synthesises a mouseenter, which opened the panel — and then the click
         handler below found it already open and let the link through, so a tap
         did both at once and the panel flashed on the way to the collection. */
      [btn, panel].forEach(function (el) {
        el.addEventListener('mouseenter', function () { if (DESK.matches && HOVER.matches) open(); });
        el.addEventListener('mouseleave', function () { if (DESK.matches && HOVER.matches) leave(); });
      });
      btn.addEventListener('focus', function () {
        if (!DESK.matches || panel.ntlNoOpen) return;
        /* Focus-to-open is for the KEYBOARD, and a pointer press fires focus
           too — so on a touch screen the panel was already open by the time the
           click handler below looked, and the tap fell through to the link.
           :focus-visible is precisely the "arrived here by keyboard" signal. */
        var byKeyboard = true;
        try { byKeyboard = btn.matches(':focus-visible'); } catch (err) { byKeyboard = true; }
        if (byKeyboard) open();
      });

      /* TOUCH, above the drawer breakpoint — a tablet in landscape is wider than
         901px, so it gets the desktop panel, but it has no hover to open it
         with. A tap just followed the link and the entire mega menu was
         unreachable on the device. First tap opens it, second tap follows the
         link, which is the behaviour every other touch mega menu has. */
      btn.addEventListener('click', function (e) {
        if (!DESK.matches || HOVER.matches) return;
        if (!panel.classList.contains('on')) { e.preventDefault(); open(); }
      });

      /* KEYBOARD. The panel is the last thing in the header's markup, so Tab
         from the trigger walks the rest of the nav and the whole icon rail
         before it gets there — and the focus-out handler has closed the panel
         long before then. A keyboard user could not reach a single one of these
         links. Hand focus straight in instead, and let Shift+Tab out of the
         first link go back to the trigger, so the panel behaves like the one
         stop in the tab order it looks like. */
      function focusables() {
        return $$('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])', panel);
      }
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || e.shiftKey || !panel.classList.contains('on')) return;
        var f = focusables();
        if (!f.length) return;
        e.preventDefault();
        f[0].focus();
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !e.shiftKey) return;
        var f = focusables();
        if (f.length && e.target === f[0]) { e.preventDefault(); btn.focus(); }
      });

      DESK.addEventListener('change', shut);
    });
  }

  /* ── 11b) COMPARE SWATCHES — pick a colour, both faces follow ──────────
     Every colour's front/reverse pair is already in the DOM; choosing one just
     unhides its pair. Swapping src instead would mean rebuilding srcset here
     and showing a reload on every click.
     Delegated, so it survives shopify:section:load like everything else. */
  on('click', '[data-ntl-swatch]', function (e, btn) {
    var group = btn.closest('.ntl-compare, section');
    if (!group) return;
    var idx = btn.dataset.ntlSwatch;

    $$('[data-ntl-sw]', group).forEach(function (img) {
      img.hidden = img.dataset.ntlSw !== idx;
    });
    $$('[data-ntl-swatch]', group).forEach(function (b) {
      b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
    });

    var name = group.querySelector('[data-ntl-swatch-name]');
    if (name && btn.dataset.swName) name.textContent = btn.dataset.swName;

    /* the button must never point at a different colour than the one shown */
    var cta = group.querySelector('[data-ntl-swatch-cta]');
    if (cta) {
      if (btn.dataset.swUrl) cta.href = btn.dataset.swUrl;
      if (btn.dataset.swCta) cta.textContent = btn.dataset.swCta;
    }
  });

  /* arrow keys move within the group, as a radiogroup should */
  on('keydown', '[data-ntl-swatch]', function (e, btn) {
    if (!/^Arrow(Left|Right|Up|Down)$/.test(e.key)) return;
    var group = btn.closest('.ntl-compare, section');
    if (!group) return;
    var all = $$('[data-ntl-swatch]', group);
    var i = all.indexOf(btn);
    if (i < 0) return;
    e.preventDefault();
    var step = (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 1;
    var next = all[(i + step + all.length) % all.length];
    next.focus();
    next.click();
  });

  /* ── 12) READ-MORE clamp — progressive enhancement, never hides content ─ */
  function initClamps() {
    $$('.ntl [data-ntl-clamp]').forEach(function (el) {
      if (el.dataset.ntlClampInit) return;
      el.dataset.ntlClampInit = '1';
      var toggle = document.querySelector('[data-ntl-clamp-toggle="' + el.id + '"]');
      if (!toggle) return;
      function measure() {
        if (el.dataset.ntlUser === '1') return;
        var overflowing = el.scrollHeight > el.clientHeight + 2;
        if (overflowing) { toggle.hidden = false; }
        else { el.classList.add('is-expanded'); toggle.hidden = true; }
      }
      measure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      toggle.addEventListener('click', function () {
        el.dataset.ntlUser = '1';
        var open = el.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var label = toggle.querySelector('[data-ntl-clamp-label]');
        if (label) label.textContent = open ? (toggle.dataset.less || 'Read less') : (toggle.dataset.more || 'Read more');
      });
    });
  }

  /* ── 13) COMPARE / WIPE slider (drag + keyboard + touch) ─────────────── */
  function initWipe() {
    $$('.ntl [data-ntl-wipe]').forEach(function (box) {
      if (box.dataset.ntlWipeInit) return;
      box.dataset.ntlWipeInit = '1';
      var top = box.querySelector('[data-ntl-wipe-top]');
      var hand = box.querySelector('[data-ntl-wipe-handle]');
      var hint = box.querySelector('[data-ntl-wipe-hint]');
      if (!top || !hand) return;
      var pos = parseFloat(box.dataset.ntlWipe) || 58, dragging = false, touched = false;
      function set(v) {
        pos = Math.max(4, Math.min(96, v));
        top.style.clipPath = 'inset(0 ' + (100 - pos).toFixed(2) + '% 0 0)';
        hand.style.left = pos + '%';
        hand.setAttribute('aria-valuenow', Math.round(pos));
      }
      set(pos);
      function from(e) {
        var r = box.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        set((x / r.width) * 100);
        if (!touched && hint) { touched = true; hint.classList.add('gone'); }
      }
      box.addEventListener('mousedown', function (e) { dragging = true; from(e); e.preventDefault(); });
      window.addEventListener('mousemove', function (e) { if (dragging) from(e); });
      window.addEventListener('mouseup', function () { dragging = false; });
      box.addEventListener('touchstart', function (e) { dragging = true; from(e); }, { passive: true });
      box.addEventListener('touchmove', function (e) { if (dragging) from(e); }, { passive: true });
      box.addEventListener('touchend', function () { dragging = false; });
      hand.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { set(pos - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { set(pos + 5); e.preventDefault(); }
        if (e.key === 'Home') { set(4); e.preventDefault(); }
        if (e.key === 'End') { set(96); e.preventDefault(); }
      });
    });
  }

  /* ── 14) VIDEO FACADE — YouTube/Vimeo iframe only on click (§12.4c) ──── */
  on('click', '[data-ntl-facade]', function (e, btn) {
    e.preventDefault();
    var src = btn.dataset.ntlFacade;
    if (!src) return;
    var frame = document.createElement('iframe');
    frame.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    frame.setAttribute('allow', 'accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture');
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
    frame.loading = 'lazy';
    frame.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
    var host = btn.closest('[data-ntl-facade-host]') || btn.parentElement;
    host.innerHTML = ''; host.appendChild(frame);
  });

  /* ── boot + re-init on every Shopify section render ──────────────────── */
  function initAll() {
    initReveal(); initVideo(); initRails(); initCounters();
    initMega(); initClamps(); initWipe();
    syncWishlist(); renderWishlist();
    loadProductRecs();
  }
  NTL.initAll = initAll;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('shopify:block:select', initAll);
  window.addEventListener('kt.cart.reloaded', function () { setTimeout(initAll, 0); });
})();


/* ── --ntl-header-h ───────────────────────────────────────────────────────────
   The real, measured height of the sticky header group, published as a custom
   property so anything that has to sit below it stops guessing.

   The collection filter rail guessed 84px against a header that is 112px, so it
   stuck 28px UNDER it: scroll a collection and the rail's own "Product type"
   heading disappeared behind the header while the checkboxes below it stayed —
   the rail looked cropped rather than stuck. The number also changes: the
   announcement bar can be switched off, and the header is a different height on
   a phone, so a second hard-coded guess would only have been wrong somewhere
   else. */
(function () {
  'use strict';
  var g = document.getElementById('header-group');
  if (!g) return;
  var last = -1;
  function publish() {
    var h = Math.round(g.getBoundingClientRect().height);
    if (h === last || !h) return;
    last = h;
    document.documentElement.style.setProperty('--ntl-header-h', h + 'px');
  }
  publish();
  if (window.ResizeObserver) new ResizeObserver(publish).observe(g);
  window.addEventListener('resize', publish, { passive: true });
  window.addEventListener('load', publish);
  document.addEventListener('shopify:section:load', publish);
})();
